import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedInUser } from "../utils/store";
const Missing = ({ message }) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  return (
    <section className="auth-page overflow-hidden">
      <div className="conatiner h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 col-md-6 col-lg-4 text-center">
            {message ? null : <h1>oops!</h1>}
            <h2 className="mb-4">
              {message ? message : "Error 404 : Page Not Found"}
            </h2>

            {message ? null : loggedUser?.role?.includes("team_owner") ? (
              <Link to="/team" className="btn btn-primary">
                Go Back Homepage
              </Link>
            ) : (
              <Link to="/" className="btn btn-primary">
                Go Back Homepage
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Missing;
